// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"ya_a bii_vp bii_vh bii_xe bii_rg bii_tr bii_qx"};